import { render, staticRenderFns } from "./LayoutCentered.global.vue?vue&type=template&id=1c0d9fbc&scoped=true&lang=pug&"
import script from "./LayoutCentered.global.vue?vue&type=script&lang=ts&"
export * from "./LayoutCentered.global.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutCentered.global.vue?vue&type=style&index=0&id=1c0d9fbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0d9fbc",
  null
  
)

export default component.exports